import { render } from "./Vue_js.vue?vue&type=template&id=44f577b4"
import script from "./Vue_js.vue?vue&type=script&lang=js"
export * from "./Vue_js.vue?vue&type=script&lang=js"

import "./Vue_js.vue?vue&type=style&index=0&id=44f577b4&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__